import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Core2Config } from '../shared/core2Config';
import { InventoryPdgGuideElementContainerModel } from '../../../../../models/aggregates/Inventory-pdg-guide-element';
import { BaseApiPublicLoginTemplateService } from '../shared/base-api-public-login-template.service';

@Injectable({
  providedIn: 'root'
})
export class InventoryPdgGuideElementService extends BaseApiPublicLoginTemplateService<InventoryPdgGuideElementContainerModel,InventoryPdgGuideElementContainerModel,InventoryPdgGuideElementContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'pdg-guide-elements/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.INV_PREFIX + 'pdg-guide-elements/' + Core2Config.BACKOFFICE_EP_SUFFIX;
    this.httpClient = http;
  }
}